var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69692 11.7638H4.71453C4.20989 11.7638 3.80078 11.3547 3.80078 10.85C3.80078 10.3453 4.20985 9.93628 4.71453 9.93628H9.69692C10.2016 9.93628 10.6107 10.3453 10.6107 10.85C10.6107 11.3547 10.2016 11.7638 9.69692 11.7638Z",
    fill: "#FF761C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69695 12.1751C9.19232 12.1751 8.7832 11.766 8.7832 11.2613V4.71355C8.7832 4.20892 9.19227 3.7998 9.69695 3.7998C10.2016 3.7998 10.6107 4.20887 10.6107 4.71355V11.2614C10.6107 11.766 10.2016 12.1751 9.69695 12.1751Z",
    fill: "#FF761C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69774 12.8762C10.8166 12.8762 11.7236 11.9692 11.7236 10.8503C11.7236 9.73148 10.8166 8.82446 9.69774 8.82446C8.57889 8.82446 7.67188 9.73148 7.67188 10.8503C7.67188 11.9692 8.57889 12.8762 9.69774 12.8762Z",
    fill: "#FF761C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.6,
    stroke: "#FF761C",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingUser);
export default __webpack_public_path__ + "static/media/pending-user.2d6f61a7b856ce7da03e7208637e4fb0.svg";
export { ForwardRef as ReactComponent };